import { useState, useEffect, useContext } from 'react'
import { DealerContext } from '@/context/DealerContext'
import PersistedLink from './PersistedLink'

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const dealerContext = useContext(DealerContext)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }
    handleScroll()

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      <header className='text-sm h-20 group' data-is-scrolled={isScrolled || null}>
        <div className='fixed top-0 z-20 left-0 w-full px-12 max-xl:px-0 max-xl:shadow-xl transition-all duration-300 group-data-[is-scrolled]:px-0 max-xl:group-data-[mobile-menu]:bg-white'>
          <div className='relative bg-white transition-all duration-300 h-[72px] rounded-full px-4 flex items-center justify-between translate-y-4 max-xl:translate-y-0 max-xl:rounded-none group-data-[is-scrolled]:rounded-none group-data-[is-scrolled]:translate-y-0'>
            <PersistedLink to='/' className='w-[120px] md:w-[134px] mr-1 md:mx-6 flex items-center h-[72px]'>
              <img
                className='w-full'
                src={dealerContext?.themeLogo || '/brand/udc/site-logo.png'}
                alt='Logo'
              />
            </PersistedLink>
          </div>
        </div>
      </header>
    </>
  )
}

export { Header }
